module.exports = __webpack_public_path__ + "img/TUR_darwin.e93e31ca.jpg";